import { MDBIcon } from 'mdbreact';
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Swal from 'sweetalert2';

class InicioGlobal extends Component {
    logout = () => {
        const { idUsuarioKey, usuarioKey, redirectPath, history } = this.props;
        Swal.fire({
            text: "¿Estás seguro de cerrar sesión?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#00c851',
            cancelButtonColor: '#d33',
            confirmButtonText: 'SI',
            cancelButtonText: 'NO'
        }).then((result) => {
            if (result.value) {
                Swal.fire(
                    '',
                    'Se cerró sesión exitosamente!',
                    'success'
                )
                sessionStorage.removeItem(idUsuarioKey);
                sessionStorage.removeItem(usuarioKey);
                history.push(redirectPath);
            }
        });
    }
    render() {
        const { usuario, cargo } = this.props;
        return (
            <React.Fragment>
                <p className="my-0 font-weight-bold" style={{ fontSize: '25px' }}>
                    Bienvenido - {usuario}
                </p>
                <span>Cargo: {cargo}</span>
                <hr />
                <div className="btn_cerrar_sesion">
                    <button
                        onClick={this.logout}
                        className="btn px-4 py-2 text-dark"
                        style={{ background: '#f47216' }}
                    >
                        Cerrar Sesión &nbsp;
                        <MDBIcon icon="sign-out-alt" />
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(InicioGlobal);